import Vue from 'vue';
import Router, { RouteConfig, RouterOptions } from 'vue-router';

// Components

import Login from '@/components/Login.vue';
import Register from '@/components/Register.vue';
import Smartchronos from '@/environments/Smartchronos.vue';
import Alertas from '@/components/smartchronos/Alertas.vue';
import RealTime from '@/components/smartchronos/RealTime.vue';
import Habitos from '@/components/smartchronos/Habitos.vue';
import Ajustes from '@/components/smartchronos/ajustes/Ajustes.vue';
import MiPerfil from '@/components/smartchronos/MiPerfil.vue';
import Administracion from '@/components/smartchronos/administracion/Administracion.vue';
import ChooseProject from '@/components/smartchronos/ChooseProject.vue';
import RecoveryPassword from '@/components/RecoveryPassword.vue';
import ConfirmarCuenta from '@/components/ConfirmarCuenta.vue';
import SetPassword from '@/components/SetPassword.vue';
import Facturacion from '@/components/smartchronos/Facturacion.vue';
import Login2 from '@/components/Login2.vue';
import { Auth, oAuth } from './classes/Auth';
import axios from 'axios';


import Dashboard from '@/components/smartchronos/Dashboard.vue';
import Dashboard2 from '@/components/smartchronos/Dashboard2.vue';
import Dashboard3 from '@/components/smartchronos/Dashboard3.vue';
import d4 from '@/components/smartchronos/dashboards/dashboard4.vue';
import d5 from '@/components/smartchronos/dashboards/dashboard5.vue';
import d6 from '@/components/smartchronos/dashboards/dashboard6.vue';
import d7 from '@/components/smartchronos/dashboards/dashboard7.vue';
import d8 from '@/components/smartchronos/dashboards/dashboard8.vue';
import d9 from '@/components/smartchronos/dashboards/dashboard9.vue';
import d10 from '@/components/smartchronos/dashboards/dashboard10.vue';
import d11 from '@/components/smartchronos/dashboards/dashboard11.vue';

import store from './store'
import { hasPermission } from './libs/helpers';


Vue.use(Router);

const auth = new Auth;



const router: RouterOptions = {
    mode: 'history',
    routes: [
        {
            path: '/login',
            component: Login2
        },
        {
            path: '/',
            component: Login,
            beforeEnter: function (to: any, from: any, next: any) {
                const usr = auth.getUser();
                const token = auth.getToken();
                if (usr && token) {
                    next('/smartchronos/dashboard2')
                } else {
                    next();
                }
            }
        },
        {
            path: '/register',
            component: Register
        },
        {
            path: '/confirm-account/:token',
            component: ConfirmarCuenta,
            beforeEnter: function (to: any, from: any, next: any) {
                const { token } = to.params;
                const { type } = to.query;
                console.log(type);
                axios({
                    'url': `${process.env.VUE_APP_BACKEND}/validate-confirm-token`,
                    method: 'POST',
                    data: {
                        token: token,
                        type
                    }
                })
                    .then((res: any) => { console.log(res); next(`/set-password/${res.data.token}?type=${res.data.type}`) })
                    .catch(err => {
                        Vue.swal('Error', err.response.data, 'error')
                        next('/');
                    })
            }
        },
        {
            path: '/recovery-password/:token',
            component: Smartchronos,
            children: [
                {
                    path: "",
                    component: RecoveryPassword,
                }],
            beforeEnter: function (to: any, from: any, next: any) {
                const token = to.params.token;
                axios({
                    'url': `${process.env.VUE_APP_BACKEND}/validate-password-recovery-token`,
                    method: 'POST',
                    data: {
                        token: token
                    }
                })
                    .then(res => { console.log(res); next() })
                    .catch(err => {
                        Vue.swal('Error', err.response.data, 'error')
                        next('/');
                    })
            }
        },
        {
            path: "/set-password/:token",
            component: SetPassword,
            beforeEnter: function (to: any, from: any, next: any) {
                const token = to.params.token;
                axios({
                    "url": `${process.env.VUE_APP_BACKEND}/validate-password-recovery-token`,
                    method: "POST",
                    data: {
                        token: token
                    }
                })
                    .then(res => { console.log(res); next() })
                    .catch(err => {
                        Vue.swal("Error", err.response.data, "error")
                        next("/");
                    })
            }
        },
        {
            path: '/smartchronos',
            component: Smartchronos,
            children: [
                {
                    path: '',
                    redirect: 'dashboard2'
                },
                {
                    path: 'dashboardagua',
                    component: Dashboard3
                },
                {
                    path: 'dashboard',
                    component: Dashboard,

                },
                {
                    path: 'dashboard2',
                    component: Dashboard2,

                },
                {
                    path: 'dashboard4',
                    component: d4,

                },
                {
                    path: 'dashboard5',
                    component: d5,

                },
                {
                    path: 'dashboard6',
                    component: d6,

                },
                {
                    path: 'dashboard7',
                    component: d7,

                },
                {
                    path: 'dashboard8',
                    component: d8,

                },
                {
                    path: 'dashboard9',
                    component: d9,

                },
                {
                    path: 'dashboard10',
                    component: d10,

                },
                {
                    path: 'dashboard11',
                    component: d11,

                },
                {
                    path: 'habitos-consumo',
                    component: Habitos,
                    beforeEnter: (from: any, to: any, next: any) => {
                        if (!hasPermission('HABITOS') && !oAuth.isVertebra()) {
                            next('/smartchronos/dashboard2')
                        }
                        next();
                    }
                },
                {
                    path: 'mi-perfil',
                    component: MiPerfil
                },
                {
                    path: 'real-time',
                    component: RealTime,
                    beforeEnter: (from: any, to: any, next: any) => {
                        if (!hasPermission('REALTIME') && !oAuth.isVertebra()) {
                            next('/smartchronos/dashboard2')
                        }
                        next();
                    }
                },
                {
                    path: 'facturacion',
                    component: Facturacion,
                    beforeEnter: (from: any, to: any, next: any) => {
                        if (!hasPermission('FACTURACION') && !oAuth.isVertebra()) {
                            next('/smartchronos/dashboard2')
                        }
                        next();
                    }
                },
                {
                    path: 'ajustes',
                    component: Ajustes,
                    beforeEnter: function (from: any, to: any, next: any) {
                        const rol = auth.getRol();
                        if (['ADMIN'].includes(rol) || auth.isVertebra()) {
                            next();
                        } else {
                            next('/smartchronos/dashboard2')
                        }

                    }
                },
                {
                    path: 'administracion',
                    component: Administracion,
                    beforeEnter: function (from: any, to: any, next: any) {
                        auth.getRol();
                        const usr = auth.getUser();
                        if (auth.isSuperadmin() && auth.isVertebra()) {
                            next();
                        } else {
                            auth.getRol();
                            next('/smartchronos/dashboard2')
                        }

                    }
                },
                {
                    path: 'dcreator',
                    component: () => import('./components/smartchronos/DCreator.vue'),
                    beforeEnter: function (from: any, to: any, next: any) {
                        auth.getRol();
                        const usr = auth.getUser();
                        if (auth.isSuperadmin() && auth.isVertebra()) {
                            next();
                        } else {
                            auth.getRol();
                            next('/smartchronos/dashboard2')
                        }

                    }
                },
                {
                    path: 'alertas',
                    component: Alertas,
                    beforeEnter: function (from: any, to: any, next: any) {
                        auth.getRol();
                        const usr = auth.getUser();
                        if (auth.isSuperadmin() && auth.isVertebra()) {
                            next();
                        } else {
                            auth.getRol();
                            next('/smartchronos/dashboard2')
                        }

                    }
                }
            ],
            beforeEnter: function (from: any, to: any, next: any) {
                if (!auth.getProject()) {
                    next('/choose-project')
                }

                next();

            },

        },
        {
            path: '/dcreator',
            component: () => import('./components/smartchronos/DCreator.vue'),
        },
        {
            path: '/choose-project',
            component: ChooseProject,
            beforeEnter: function (from: any, to: any, next: any) {
                if (!auth.getToken() || !auth.getUser()) {
                    next('/')
                }
                if (auth.getProject()) {
                    next('/smartchronos/dashboard2')
                }
                next();
            }
        },
        {
            path: '/maintenance',
            component: () => import('./components/Maintenance.vue')
        },
        {
            path: '*',
            redirect: '/smartchronos'
        }
    ]
}

export default new Router(router);